import { useState, useEffect } from 'react';
import {useGlobalStore} from '../../store/hooks/useStore'

function useCustomSitePreference(preferenceKey:string, defaultValue:any) {
  const {getCustomSitePreferenceById} = useGlobalStore()
  const [value, setValue] = useState(defaultValue);

  const loadPreference = async () => {
    try {
      const fetchedPreference = await getCustomSitePreferenceById(preferenceKey)
      setValue(fetchedPreference)
    } catch (error) {
      console.error(`Failed to load preference for ${preferenceKey}:`, error);
    }
  };

  useEffect(() => {
    loadPreference();
  }, []);

  return value; 
}

export default useCustomSitePreference;
